import { uniqId, _, reloadUrl, AppLoaderType, HostApp } from '@zto/zpage'
import type { App, AppAuthLoader, NavMenuItem } from '@zto/zpage'

import { clearAppAuthData } from '../../utils'

/** iam菜单项 */
interface IAMMenuItem {
  menuId: string // 菜单id
  parentMenuId: number // 父级菜单id
  menuName: string // 菜单名称（标题）
  keyName: string // 菜单编号
  icon: string // 菜单图标
  name: string // 权限名称
  path: string // 菜单链接
  ordinal: number // 排序号
  children?: IAMMenuItem[] // 子菜单

  [prop: string]: any
}

export const IAMAuthLoader: AppAuthLoader = {
  type: AppLoaderType.AUTH,

  name: 'iam',

  // 检查用户权限
  async checkAuth(app: App) {
    const accessToken = app.token.getAccessToken()

    if (!accessToken) throw new Error('用户未登录或登录已过期')

    return true // TODO: 暂时不校验用户权限，直接通过
    // // 从url获取code
    // const searchParams = new URL(window.location.href).searchParams
    // const code = searchParams.get('code')
    // const token = searchParams.get('token')

    // // 刷新token
    // if (code) {
    //   // 刷新并设置token
    //   await app.token.refresh(code)
    // } else if (token) {
    //   await app.token.setAccessToken(token)
    // } else {
    //   // 重设token
    //   await app.token.reset()
    // }

    // if (!app.token.getAccessToken()) {
    //   await app.logout()
    // } else if (code) {
    //   await reloadUrl()
    // }
  },

  // 获取用户信息
  async getUserInfo(app: App) {
    const { authApi } = app.apis

    if (!authApi.getUserInfo) {
      throw new Error('当前接口没有定义获取用户信息方法，请在接口中添加getUserInfo方法')
    }

    const res = await authApi.getUserInfo()
    console.log('res===', res)

    return res
  },

  // 解析菜单数据
  async getMenuData(app: App) {
    // const menus = app.stores.userStore.menus || []

    const menus = [
      {
        menuId: 'me251224000001',
        parentMenuId: '-1',
        keyName: 'me251224000001',
        menuName: '流量运营',
        name: '流量运营',
        path: null,
        order: 0,
        bizId: '',
        children: [
          // {
          //   menuId: 'me251224000003',
          //   parentMenuId: 'me251224000001',
          //   keyName: 'kt.operatewebdemo.goods',
          //   menuName: '商品管理',
          //   name: '商品管理',
          //   path: '/operatewebdemo/goods',
          //   order: 0,
          //   bizId: 'P1743648109029',
          //   parentName: 'me251224000001'
          // },
          // {
          //   menuId: 'me251224000004',
          //   parentMenuId: 'me251224000002',
          //   keyName: 'goodsedit',
          //   menuName: '商品编辑',
          //   name: '商品编辑',
          //   path: '/goodsedit',
          //   hidden:true,
          //   visible:false,
          //   order: 0,
          //   bizId: 'P1343648109030',
          //   parentName: 'me231224000001'
          // },
          {
            menuId: 'me251224000004',
            parentMenuId: 'me251224000002',
            keyName: 'goodsList',
            menuName: '商品列表',
            name: '商品列表',
            path: '/goods',
            order: 0,
            bizId: 'P1343648109030',
            parentName: 'me231224000001'
          },
          {
            menuId: 'me251224000005',
            parentMenuId: 'me251224000003',
            keyName: 'nwcategory',
            menuName: '分类管理',
            name: '分类管理',
            path: '/newcategory',
            order: 0,
            bizId: 'P1743648109031',
            parentName: 'me251224000001'
          },

          {
            menuId: 'me251224000006',
            parentMenuId: 'me251224000004',
            keyName: 'addnewcoupon',
            menuName: '优惠券管理',
            name: '优惠券管理',
            path: '/addnewcoupon',
            order: 0,
            bizId: 'P1743648109031',
            parentName: 'me251224000001'
          },
          {
            menuId: 'me251224000006',
            parentMenuId: 'me251224000004',
            keyName: 'placement',
            menuName: '资源位管理',
            name: '资源位管理',
            path: '/placement',
            order: 0,
            bizId: 'P1743648109031',
            parentName: 'me251224000001'
          },
          {
            menuId: 'me251224000006',
            parentMenuId: 'me251224000004',
            keyName: 'activity',
            menuName: '活动管理',
            name: '活动管理',
            path: '/activity',
            order: 0,
            bizId: 'P1743648109031',
            parentName: 'me251224000001'
          },
          // {
          //   menuId: 'me251224000006',
          //   parentMenuId: 'me251224000004',
          //   keyName: 'activitynew',
          //   menuName: '新活动管理',
          //   name: '新活动管理',
          //   path: '/activitynew',
          //   order: 0,
          //   bizId: 'P1743648109031',
          //   parentName: 'me251224000001'
          // },
          {
            menuId: 'me251224000009',
            parentMenuId: 'me251224000009',
            keyName: 'orderlist',
            menuName: '订单列表',
            name: '订单列表',
            path: '/orderlist',
            order: 0,
            bizId: 'P1743648109031',
            parentName: 'me251224000001'
          },
          {
            menuId: 'me251224000029',
            parentMenuId: 'me251224000029',
            keyName: 'refund',
            menuName: '退货单列表',
            name: '退货单列表',
            path: '/refund',
            order: 0,
            bizId: 'P1743648109031',
            parentName: 'me251224000001'
          },
          // {
          //   menuId: 'me251224000029',
          //   parentMenuId: 'me251224000029',
          //   keyName: 'splitbillconfiguration',
          //   menuName: '分账配置',
          //   name: '分账配置',
          //   path: '/splitbillconfiguration',
          //   order: 0,
          //   bizId: 'P1743648109031',
          //   parentName: 'me251224000001'
          // },
          {
            menuId: 'me251224000030',
            parentMenuId: '-1',
            keyName: 'datastats',
            menuName: '数据统计',
            name: '数据统计',
            path: null,
            order: 99,
            bizId: '',
            children: [
              {
                menuId: 'me251224000031',
                parentMenuId: 'me251224000030',
                keyName: 'app.datastats.transactiondata',
                menuName: '交易数据',
                name: '交易数据',
                path: '/transactiondata',
                order: 0,
                bizId: 'P1743648109032',
                parentName: 'datastats'
              }
            ]
          },
          {
            menuId: 'me251224000040',
            parentMenuId: '-1',
            keyName: 'commission',
            menuName: '佣金管理',
            name: '佣金管理',
            path: null,
            order: 100,
            bizId: '',
            children: [
              {
                menuId: 'me251224000041',
                parentMenuId: 'me251224000040',
                keyName: 'app.commission.record',
                menuName: '佣金记录',
                name: '佣金记录',
                path: '/commission/record',
                order: 0,
                bizId: 'P1743648109040',
                parentName: 'commission'
              },
              {
                menuId: 'me251224000042',
                parentMenuId: 'me251224000040',
                keyName: 'app.commission.validOrders',
                menuName: '有效订单',
                name: '有效订单',
                path: '/commission/valid-orders',
                order: 1,
                bizId: 'P1743648109041',
                parentName: 'commission'
              },
              {
                menuId: 'me251224000043',
                parentMenuId: 'me251224000040',
                keyName: 'app.commission.withdraw',
                menuName: '提现记录',
                name: '提现记录',
                path: '/commission/withdraw',
                order: 2,
                bizId: 'P1743648109042',
                parentName: 'commission'
              },
              {
                menuId: 'me251224000044',
                parentMenuId: 'me251224000040',
                keyName: 'app.commission.fans',
                menuName: '粉丝关系',
                name: '粉丝关系',
                path: '/commission/fans',
                order: 3,
                bizId: 'P1743648109043',
                parentName: 'commission'
              }
            ]
          }
        ]
      }
    ]

    const navMenus = menus.map((it: any) => {
      return parseMenuItem(it)
    })

    return navMenus
  },

  async logout(app: App, args: any) {
    app.token.clearData()

    /** 若当前页不在登录页则刷新页面 */
    if (app.router.currentRoute.value.name !== 'login') {
      await reloadUrl(window.location.origin)
    }
    // if (!app.isIndependent && HostApp.loaded) {
    //   await HostApp.logout()
    //   return
    // }

    // const { authApi } = app.apis

    // if (authApi.logout) {
    //   await authApi.logout(args)
    // } else {
    //   await iamLogout(app)
    // }
  },

  async iamLogout(app: App) {
    return iamLogout(app)
  }
}

/** iam登出 */
async function iamLogout(app: App) {
  const ENV = app.hostEnv

  await app.token.clearData()

  clearAppAuthData()

  const redirectUrl = encodeURIComponent(window.location.origin)
  const loginUrl = `${ENV.iamUrl}/oauth2?app_id=${ENV.appId}&redirect_url=${redirectUrl}&state=${uniqId()}`

  await reloadUrl(loginUrl)
}

// 解析单项菜单
function parseMenuItem(menu: IAMMenuItem): NavMenuItem {
  const children = (menu.children || []).map(it => {
    it.parentName = menu.keyName
    return parseMenuItem(it)
  })

  // 原始菜单数据(忽略children项)
  const data = _.omit(menu, ['children'])

  return {
    name: menu.keyName,
    parentName: menu.parentName,
    title: menu.menuName,
    icon: menu.icon,
    path: menu.path,
    order: menu.order || menu.ordinal || 0,
    bizId: menu.bizId,
    data,
    children
  }
}
